import styled from 'styled-components';

import * as PetcoUI from 'petco-ui/elements/form/input/Input.styled';
import { rem, themed } from '@/shared/ui/core';

export const InputStyled = styled(PetcoUI.InputStyled).attrs({
  className: 'InputStyled',
})`
  border-radius: 4px;
  height: 2.75rem;
`;

export const InputWrapper = styled(PetcoUI.InputWrapper)`
  input.InputStyled {
    color: ${themed('primary.text')};
    font-size: ${themed('input.fontSize', rem)};
    padding: ${({ $hasLabel }) => $hasLabel ? '0.95rem 0.25rem 0 0.55rem' : '0 0.75rem'};
    transition: none;

    &:placeholder-shown {
      padding: 0 0.75rem;
    }

    &::placeholder {
      color: ${themed('primary.darkGray')}99;
      font-size: ${themed('input.fontSize', rem)};
      opacity: 1;
    }

    & + label.LabelInput {
      color: ${themed('primary.darkGray')};
      font-size: 0.625rem;
      opacity: 0;
      overflow: visible;
      text-transform: uppercase;
      transform: translate(0.8125rem, -0.5rem) scale(1);
      transition: all 100ms ease-in-out;
    }

    &:not(:placeholder-shown), &:focus {
      padding: ${({ $hasLabel }) => $hasLabel ? '0.95rem 0.25rem 0 0.75rem' : '0 0.75rem'};

      &::placeholder {
        opacity: 0;
      }

      & + label {
        opacity: 1;
        transform: translate(0.8125rem, -0.875rem) scale(1);
      }
    }
  }

  svg {
    height: 1rem;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;

    path {
      fill: ${themed('status.success')};
    }
  }
`;

export const LabelInput = styled(PetcoUI.LabelInput).attrs({
  className: 'LabelInput',
})``;
